// extracted by mini-css-extract-plugin
export var markdown = "_vc-0";
export var tableWrapper = "_vc-1";